export const getUsername = () => window.location.hostname.match(/^[A-Za-z0-9-_]*/)[0]



// WEBPACK FOOTER //
// ./src/utils/location.js